import type { FC } from "react";

import Carousel from "@/design-system/carousel";
import { useViewportInfoContext } from "@/src/contexts";
import * as stylex from "@stylexjs/stylex";

import type { ICashbackBannerElement } from "../CashbackCommonInterfaces";
import BannerTile from "./BannerTile";

const styles = stylex.create({
    freeScroll: {
        scrollSnapType: "unset",
    },

    carouselOverride: {
        scrollSnapType: "x mandatory",
    },
});

export interface IBannerSection {
    initialData: ICashbackBannerElement[];
}

const BannerSection: FC<IBannerSection> = ({ initialData }) => {
    const { isMobile, isLaptop } = useViewportInfoContext();

    return (
        <div>
            {initialData && (
                <Carousel
                    itemsToShow={isMobile ? 1.1 : isLaptop ? 2 : 3}
                    showArrows={!isMobile}
                    styleX={[styles.carouselOverride, isMobile && styles.freeScroll]}
                >
                    {initialData.map((item: ICashbackBannerElement, index: number) => (
                        <BannerTile
                            key={(item && item.id) || index}
                            id={(item && item.id) || ""}
                            title={item.title}
                            bannerImageUrl={item.imageUrlDesktop || ""}
                            navigateBannerUrl={item.link?.navigateUrl}
                        />
                    ))}
                </Carousel>
            )}
        </div>
    );
};

export default BannerSection;
